export default function ChartCard({
  title,
  subtitle,
  children,
  actions,
  className = '',
  height = 'h-80'
}) {
  const heightClass = height === 'h-auto' ? '' : height

  return (
    <div className={`card overflow-hidden ${className}`}>
      {(title || actions) && (
        <div className="card-header flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white">
              {title}
            </h3>
            {subtitle && (
              <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
                {subtitle}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 flex-shrink-0">
              {actions}
            </div>
          )}
        </div>
      )}
      <div className={`card-body ${heightClass} ${height !== 'h-auto' ? 'overflow-hidden' : ''}`}>
        {children}
      </div>
    </div>
  )
}
